var CodeFieldData = /** @class */ (function () {
    function CodeFieldData() {
        this._value = "";
    }
    Object.defineProperty(CodeFieldData.prototype, "index", {
        get: function () {
            return this._index;
        },
        set: function (value) {
            this._index = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CodeFieldData.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    CodeFieldData.getValues = function (codeFieldsData) {
        var result = [];
        codeFieldsData.forEach(function (codeFieldData) {
            if (codeFieldData.value !== "") {
                result.push(codeFieldData.value);
            }
        });
        return result;
    };
    return CodeFieldData;
}());
export { CodeFieldData };
//# sourceMappingURL=code-field-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/text/code-field-data.js
// module id = 980
// module chunks = 14